<template>
    <div class="row" v-if=" showInfo ">
        <p class="agr text-left mt-1 p-3">
            <TruncatedText
                :truncated-text="truncatedText"
                :remaining-text="remainingText"
                more-text="Szczegóły &gt;"
                less-text="Zwiń"
            />
        </p>
    </div>
</template>

<script>
import systemConst from '@SYSTEM_CONSTANTS'
import TruncatedText from '@/components/atoms/TruncatedText';

export default {
    name: 'PersonalDataAdministratorInfo',
    props: {
        showInfo: Boolean
    },
    data() {
        return {
            systemConst,
            truncatedText: 'Administratorem Twoich danych osobowych będzie Stowarzyszenie WIOSNA z&nbsp;siedzibą w&nbsp;Krakowie (30-552) przy ul. Wielicka 20.&nbsp;',
            remainingText: 'Przysługują Ci prawa dostępu do swoich danych, ich poprawiania bądź usunięcia.\n' +
                '<a target="_blank" href="'+systemConst.SYSTEM_URL_PRIVACY_POLICY+'">Dowiedz się więcej, jak przetwarzamy Twoje dane.</a>'
        }
    },
    components: {
        TruncatedText,
    }
}
</script>
